import { render, staticRenderFns } from "./engenharia.vue?vue&type=template&id=6fd2f7ac&"
import script from "./engenharia.vue?vue&type=script&lang=js&"
export * from "./engenharia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports